import { Divider } from '@material-ui/core'
import { format } from 'date-fns'
import React from 'react'
import { DisabledToggler, EnabledToggler, Header, Row, Text } from '../Text'

function Synchronization({
  lastTime,
  isSyncNow,
  fireSync,
}: ISyncProps & ISyncDispatch) {
  const lastSync = format(lastTime, 'HH:mm:SS DD-MM')

  return (
    <React.Fragment>
      <Header>Synchronizacja</Header>
      <Divider />
      <Row>
        <Text>Ostatnia synchronizacja: {lastSync}</Text>
      </Row>
      <Row onClick={fireSync}>
        <Text>Wymuś synchronizację:</Text>
        {isSyncNow ? <EnabledToggler /> : <DisabledToggler />}
      </Row>
    </React.Fragment>
  )
}

export default Synchronization

export interface ISyncProps {
  lastTime: Date
  isSyncNow: boolean
}

export interface ISyncDispatch {
  fireSync: () => void
}
